import { render, staticRenderFns } from "./manage-issue-types.vue?vue&type=template&id=d973baf8"
import script from "./manage-issue-types.vue?vue&type=script&lang=js"
export * from "./manage-issue-types.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports